<template>
    <!-- 网站地图 -->
    <div id="siteMap-external" class="siteMap-external">
        <!-- 阴影 -->
        <div id="siteMap-shadow" class="siteMap-shadow" @click="closesitemap"></div>
        <!-- 地图栏 -->
        <div id="siteMap" class="siteMap">
            <div id="siteMap-navigation" class="siteMap-navigation">
                <div class="title">
                    <span>网站地图</span>
                    <a id="close-siteMap" href="JavaScript:;" @click="closesitemap">
                        <i class="iconfont icon-guanbi"></i>
                    </a>
                </div>
                <ul>
                    <li>
                        <p class="li-p1"><a @click="onRouter('/gsxw?subNavNumber=1')">公司新闻</a></p>
                        <p class="li-p2">
                            <a @click="onRouter('/gsxw?subNavNumber=1')">公司新闻</a>
                        </p>
                    </li>
                    <li>
                        <p class="li-p1"><a @click="onRouter('/ncpxx?subNavNumber=1')">农产品信息</a></p>
                        <p class="li-p2">
                            <a @click="onRouter('/ncpxx?subNavNumber=1')">农产品信息</a>
                        </p>
                    </li>
                    <li>
                        <p class="li-p1"><a @click="onRouter('/cybj?subNavNumber=1')">产业布局</a></p>
                        <p class="li-p2">
                            <a @click="onRouter('/cybj?subNavNumber=1')">产业布局</a>
                        </p>
                    </li>
                    <li>
                        <p class="li-p1"><a @click="onRouter('/tzzgx?subNavNumber=1')">投资者关系</a></p>
                        <p class="li-p2">
                            <a @click="onRouter('/tzzgx?subNavNumber=1')">最新公告</a>
                            <a @click="onRouter('/tzzgx?subNavNumber=2')">社会责任</a>
                            <a @click="onRouter('/tzzgx?subNavNumber=3')">联系我们</a>
                        </p>
                    </li>
                    <li>
                        <p class="li-p1"><a @click="onRouter('/ztb?subNavNumber=1')">招投标</a></p>
                        <p class="li-p2">
                            <a @click="onRouter('/ztb?subNavNumber=1')">最新采购</a>
                            <a @click="onRouter('/ztb?subNavNumber=2')">中标信息</a>
                        </p>
                    </li>
                    <li>
                        <p class="li-p1"><a @click="onRouter('/gydr?subNavNumber=1')">关于东日</a></p>
                        <p class="li-p2">
                            <a @click="onRouter('/gydr?subNavNumber=1')">企业介绍</a>
                            <a @click="onRouter('/gydr?subNavNumber=2')">管理团队</a>
                            <a @click="onRouter('/gydr?subNavNumber=3')">加入东日</a>
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import router from '@/router';
export default {
    data() {
        return {
            
        };
    },
    methods: {
        onRouter(url){
            router.push(url)
            setTimeout(()=>{
                window.location.reload()
            },100)
        },
        closesitemap(){
            let siteMap = document.getElementById('siteMap');
            let siteMapShadow = document.getElementById('siteMap-shadow');
            let siteMapNavigation = document.getElementById('siteMap-navigation');
            siteMapShadow.style.display = 'none';
            siteMapNavigation.style.transition = 'right 0.5s';
            siteMapNavigation.style.right = '-400px';
            siteMap.style.transition = 'width 0.5s'
            siteMap.style.width = '0px';
        }
    },
};
</script>
<style lang="less" scoped>
a{
    cursor: pointer;
}
</style>